/**
 * User API Client
 * Handles user profile operations
 */
import { config } from '../config';
import { useAuthStore } from '../../stores/auth.store';
const PEOPLE_API_URL = config.api.people;
/**
 * Get authorization headers with JWT token from auth store
 */
function getAuthHeaders(includeTenantId = true) {
    const { tokens, user } = useAuthStore.getState();
    const token = tokens?.idToken;
    // Read selected tenant from localStorage (set during login tenant selection)
    // Fall back to user.tenantId (from JWT) if not set
    const selectedTenantId = localStorage.getItem('selectedTenantId');
    const tenantId = selectedTenantId || user?.tenantId || 'tenant-001';
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    };
    if (includeTenantId) {
        headers['X-Tenant-Id'] = tenantId;
    }
    return headers;
}
/**
 * Get all tenants the current user has access to
 * Note: Does NOT send X-Tenant-Id header since we're querying across tenants
 *
 * GET /users/me/tenants
 */
export async function getMyTenants() {
    const response = await fetch(`${PEOPLE_API_URL}/users/me/tenants`, {
        method: 'GET',
        headers: getAuthHeaders(false), // Exclude X-Tenant-Id for cross-tenant query
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch tenants: ${response.statusText}`);
    }
    return response.json();
}
/**
 * Get current user's profile from DynamoDB (authoritative source for roles)
 * This is called after login to get fresh user data including roles.
 *
 * GET /users/me
 */
export async function getMyUser() {
    const response = await fetch(`${PEOPLE_API_URL}/users/me`, {
        method: 'GET',
        headers: getAuthHeaders(),
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch user profile: ${response.statusText}`);
    }
    return response.json();
}
